import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';

/**
 * Full-viewport crosshair overlay shown while the reporter is placing a feedback
 * marker. Dims the page, tracks the cursor with a hint pill, and emits the click
 * that should drop a marker. The host owns the actual marker injection.
 */
@Component({
  selector: 'app-placement-overlay',
  templateUrl: './placement-overlay.html',
  styleUrls: ['./placement-overlay.scss', './placement-overlay.premium.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlacementOverlay {
  /** Whether placement mode is active (overlay + hint visible). */
  readonly active = input(false);

  /** The click that should drop a marker (viewport coordinates on the event). */
  readonly place = output<MouseEvent>();

  /** Cursor-following hint position (viewport coordinates). */
  protected readonly hintX = signal(0);
  protected readonly hintY = signal(0);

  protected onMove(event: MouseEvent): void {
    this.hintX.set(event.clientX);
    this.hintY.set(event.clientY);
  }

  protected onClick(event: MouseEvent): void {
    this.place.emit(event);
  }
}
